"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneDeepByJson = void 0;
require("../../core");
// be careful with using this method
// this is not just "clone deeply" (that's why it called "byJson")
// this method is copying only primitive values (Numbers, Strings or Booleans) and nested objects with primitive values
// IT DOESNT WORK WITH:
// Dates, functions, undefined,
// Infinity, RegExps, Maps, Sets and other complex values
const cloneDeepByJson = (obj) => {
    var _a;
    let result = null;
    try {
        result = (_a = JSON.parse(JSON.stringify(obj))) !== null && _a !== void 0 ? _a : null;
    }
    catch (e) { }
    return result;
};
exports.cloneDeepByJson = cloneDeepByJson;
//# sourceMappingURL=cloneDeepByJson.js.map